<template>
    <div class="card-gold group cursor-pointer">
        <!-- Product Image -->
        <div class="relative overflow-hidden aspect-square">
            <img :src="product.image" :alt="product.title"
                class="w-full h-full object-cover transform group-hover:scale-110 transition-smooth" />
            <!-- Category Badge -->
            <div
                class="absolute top-4 right-4 bg-gold-500/90 text-richBlack px-3 py-1 rounded-full text-xs font-semibold">
                {{ product.category }}
            </div>
        </div>

        <!-- Product Info -->
        <div class="p-6">
            <h3
                class="text-xl font-display font-semibold text-gold-400 mb-2 group-hover:text-gold-300 transition-smooth">
                {{ product.title }}
            </h3>
            <p class="text-gray-400 text-sm line-clamp-2">
                {{ product.description }}
            </p>
        </div>
    </div>
</template>

<script setup>
/* eslint-disable vue/multi-word-component-names */
/**
 * ProductCard Component
 * Displays individual product information with hover effects
 */

// Props
defineProps({
    product: {
        type: Object,
        required: true,
        validator: (value) => {
            return value.id && value.title && value.image && value.category
        }
    }
})
</script>
